import { Navigate, useLocation } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import { TaleDashbaordMainCard } from "@components/TaleDashbaordMainCard";
import { TaleLoadingFallback } from "@components/TaleLoadingFallback";
import { useAdminAccess } from "@/hooks/useAdminAccess";
import { useTranslation } from "@/hooks/useTranslation";
import { layoutUtils } from "@/utils/layoutUtils";

const buttons = layoutUtils.sideBarButtons.admin;
const buttonsByPathLength = [...buttons].sort((a, b) => b.path.length - a.path.length);

// "/admin" only matches the dashboard itself; "/admin/factures/12" matches "/admin/factures"
const getMenuKeyForPath = (pathname) =>
    buttonsByPathLength.find(
        ({ path }) => pathname === path || (path !== "/admin" && pathname.startsWith(`${path}/`))
    )?.key;

const AccessDenied = () => {
    const { t } = useTranslation();
    return (
        <TaleDashbaordMainCard className="flex flex-col items-center justify-center text-center gap-3 min-h-[400px]">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-blue-50 to-purple-50">
                <FiLock className="w-10 h-10 text-blue-500" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 !m-0">{t("adminRoles.accessDeniedTitle")}</h3>
            <p className="text-gray-600 !m-0">{t("adminRoles.accessDeniedText")}</p>
        </TaleDashbaordMainCard>
    );
};

const AdminAccessGuard = ({ children }) => {
    const { pathname } = useLocation();
    const { loading, canAccess } = useAdminAccess();
    const path = pathname.replace(/\/+$/, "") || "/";

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <TaleLoadingFallback />
            </div>
        );
    }

    if (canAccess(getMenuKeyForPath(path))) return children;

    const fallback = buttons.find(({ key }) => canAccess(key));
    if (fallback && fallback.path !== path) return <Navigate to={fallback.path} replace />;

    return <AccessDenied />;
};

export default AdminAccessGuard;